<template>
	<v-container fill-height fluid class="pa-0">
		<Categoria />
		<Excluir />
		<Novo />
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="criarNovaCategoria()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170"
						locale="pt-BR" dense fixed-header class="table-item" :items="categorias" :headers="fields" :items-per-page="itensPorPagina">
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, 
	showError, 
	//showSuccess 
	} from "@/config/global"
	import axios from 'axios'
	import Categoria from '@/components/cadastros/categorias/Categoria'
	import Excluir from '@/components/cadastros/categorias/ExcluirCategoria'
	import Novo from '@/components/cadastros/categorias/NovaCategoria'
	import metodos from '@/mixins/metodos.js'
	import Br from '@/config/barramento.js'

	export default{
		mixins:[metodos],
		components:{Categoria, Excluir, Novo},
		data(){
			return {
				loading: false,
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				categorias: [],
				fields: [
					{value: 'id', text: 'Código', align: 'center'},
					{value: 'descricao', text: 'Descricao', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],

			}
		},
		methods:{
			buscaCategorias(){
				this.loading = true
				const url = `${baseApiUrl}/Cadastros/categorias/read.php`

				axios.get(url)
						.then(res => {
							if(res.data.codigo == "01"){
								this.categorias = res.data.dados
							}
							this.totalPaginas = Math.ceil(this.categorias.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
			},

			editar(categoria){
				Br.setEditarCategoria(categoria)
			},

			criarNovaCategoria(){
				Br.setNovaCategoria()
			},

			excluir(categoria){

				Br.setExcluirCategoria(categoria)
				
			}

		},

		created(){
			this.buscaCategorias()

			Br.onCategoriaExcluida(categoria => {
					let idx = this.categorias.findIndex((v) => {
                               return v.id == categoria.id
                            })

                            this.categorias.splice(idx, 1)
				})

			Br.onCategoriaCadastrada(categoria => {
				
				this.categorias.push(categoria)
			})

			Br.onCategoriaAtualizada(categoria => {
				let idx = this.categorias.findIndex((v) => {
					return v.id == categoria.id
				})

				this.categorias[idx] = categoria
			})

		}
	}
</script>

<style scoped>

</style>